import { Transaction } from '../types';
import { formatMonthYear } from './dateUtils';
import { compareTransactionDateDesc } from './dateTimeUtils';

// Group transactions by month/year
export const groupTransactionsByMonth = (transactions: Transaction[]): Record<string, Transaction[]> => {
  return transactions.reduce((acc, tx) => {
    // Use transactionDate for grouping
    const monthYear = formatMonthYear(tx.transactionDate);
    if (!acc[monthYear]) {
      acc[monthYear] = [];
    }
    acc[monthYear].push(tx);
    // Sort transactions within the group by date, descending (most recent first)
    acc[monthYear].sort((a, b) => compareTransactionDateDesc(a.transactionDate, b.transactionDate));
    return acc;
  }, {} as Record<string, Transaction[]>);
};

export const getRenderableTransactionRoots = (transactions: Transaction[]): Transaction[] => {
  const transactionIds = new Set(transactions.map((tx) => tx.id));

  return transactions.filter((tx) => tx.parentId == null || !transactionIds.has(tx.parentId));
};
